// TokenFeatures szerződés címe
export const TOKEN_FEATURES_ADDRESS = "0x71d316e10708DC840c504F33Bf8590E1c27D0846";  // Helyettesítsd a saját szerződés címével

// CreateToken szerződés címe (ha szükséges)
export const CREATE_TOKEN_ADDRESS = "0xF64da292Ac4525cb84aA7F794b248F8fb98dF23A";  // Helyettesítsd a CreateToken szerződés címével
